const MAX_INTEGER = 2147483647

const APPLICATION_COMMENT_CHAR_LIMIT = 10000

export { MAX_INTEGER, APPLICATION_COMMENT_CHAR_LIMIT }
